<template>
    <div class="JY-RZ-bg">
        <div class="container">
            <div class="col-md-8 ml-auto mr-auto" style="padding-top:40px">
                <el-steps :active="active" align-center finish-status="success">
                    <el-step title="选择身份" :description="isHuoZhu?'个人货主或企业货主':'个体司机或者物流企业'"></el-step>
                    <el-step title="完善信息" description="填写认证信息"></el-step>
                    <el-step title="提交成功" description="等待审核(1-3天)"></el-step>
                </el-steps>
            </div>
            <div v-if="active==0">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto JY-RZ">
                        <p class="p40 fp40" style="padding-top: 40px;">
                            <el-radio v-model="viewModel.IsCompany" label="1" border>个体</el-radio>
                            <el-radio v-model="viewModel.IsCompany" label="2" border>企业</el-radio>
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="active==1" class="row">
                <div class="col-md-8 ml-auto mr-auto JY-RZ">
                    <p class="p40" style="padding-top:40px;">
                        <el-form v-if="viewModel.IsCompany=='1'" ref="form1" :model="viewModel" label-width="150px" size="mini">
                            <el-form-item label="身份证号码" prop="ShenFenZheng" :rules="[
                                                        { required: viewModel.IsCompany=='1', message: '身份证号码不能为空', trigger: 'blur'},
                                                        { pattern:IDReg,message:'身份证号码不正确',trigger:'blur' }
                                                    ]">
                                <el-input v-model="viewModel.ShenFenZheng"></el-input>
                            </el-form-item>
                            <el-form-item :rules="[{ required: viewModel.IsCompany=='1'}]" label="身份证正面">
                                <el-upload :data="{type:'身份证(正面)'}" :on-change="uploadChange" :file-list="ShenFenZhengImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item :rules="[{ required: viewModel.IsCompany=='1'}]" label="身份证反面">
                                <el-upload :data="{type:'身份证(反面)'}" :on-change="uploadChange" :file-list="ShenFenZhengImages1" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item :rules="[{ required: viewModel.IsCompany=='1'}]" label="手持身份证照片">
                                <el-upload :data="{type:'手持身份证照片'}" :on-change="uploadChange" :file-list="ShouChiShenFenZhengImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item v-if="!isHuoZhu" label="我有车">
                                <el-switch v-model="viewModel.IsHaveCar"></el-switch>
                            </el-form-item>
                            <el-form-item v-if="!isHuoZhu&&viewModel.IsHaveCar" label="添加车辆">
                                <el-row>
                                    <el-col v-for="item in viewModel.Cars" :key="item.ChePaiHao" :span="8">
                                        <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                            <img :src="item.CheLiangImages[0].url" class="image">
                                            <div style="padding: 4px;">
                                                <span>车牌:{{item.ChePaiHao}}</span>
                                                <div class="bottom clearfix">
                                                    <el-button type="text" @click="removeCar(item)" class="button danger">删除</el-button>
                                                    <el-button type="text" @click="editCar(item)" class="button">编辑</el-button>
                                                </div>
                                            </div>
                                        </el-card>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-card shadow="always">
                                            <div @click="openAddCarDialog" class="add_car">
                                                <i class="el-icon-plus"></i>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item v-if="!isHuoZhu" label="我开车">
                                <el-switch v-model="viewModel.IsDriver"></el-switch>
                            </el-form-item>
                            <el-form-item class="is-required" v-if="!isHuoZhu&&viewModel.IsDriver" label="驾驶证">
                                <el-upload :data="{type:'驾驶证'}" :on-change="uploadChange" :file-list="JiaShiZhengImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <br>
                        <br>
                        <el-form v-if="viewModel.IsCompany=='2'" ref="form2" :model="viewModel.Motorcade" label-width="150px" size="mini">
                            <el-form-item prop="QiYeMingCheng" :rules="[{ required: viewModel.IsCompany=='2',message: '公司名称必填', trigger: 'blur'}]" label="公司名称">
                                <el-input v-model="viewModel.Motorcade.QiYeMingCheng"></el-input>
                            </el-form-item>
                            <el-form-item prop="ZhengZhaoNo" :rules="[{ required: viewModel.IsCompany=='2',message: '社会统一信用代码必填', trigger: 'blur'}]" label="社会统一信用代码">
                                <el-input v-model="viewModel.Motorcade.ZhengZhaoNo"></el-input>
                            </el-form-item>
                            <el-form-item prop="FangRen" :rules="[{ required: viewModel.IsCompany=='2',message: '法定代表人必填', trigger: 'blur'}]" label="法定代表人">
                                <el-input v-model="viewModel.Motorcade.FangRen"></el-input>
                            </el-form-item>
                            <el-form-item prop="YingYeQiXian" :rules="[{ required: viewModel.IsCompany=='2',message: '营业期限必填', trigger: 'blur'}]" v-if="isHuoZhu" label="营业期限">
                                <el-input v-model="viewModel.Motorcade.YingYeQiXian"></el-input>
                            </el-form-item>
                            <el-form-item prop="Address" :rules="[{ required: viewModel.IsCompany=='2',message: '注册地址必填', trigger: 'blur'}]" label="注册地址">
                                <el-input v-model="viewModel.Motorcade.Address"></el-input>
                            </el-form-item>
                            <el-form-item prop="TelPhone" v-if="isHuoZhu" label="公司电话">
                                <el-input v-model="viewModel.Motorcade.TelPhone"></el-input>
                            </el-form-item>
                            <el-form-item prop="Contact1" :rules="[{ required: viewModel.IsCompany=='2',message: '联系人必填', trigger: 'blur'}]" label="联系人">
                                <el-input v-model="viewModel.Motorcade.Contact1"></el-input>
                            </el-form-item>
                            <el-form-item prop="Contact1Phone" :rules="[{ required: viewModel.IsCompany=='2',message: '联系人电话必填', trigger: 'blur'}]" label="联系人电话">
                                <el-input v-model="viewModel.Motorcade.Contact1Phone"></el-input>
                            </el-form-item>
                            <el-form-item prop="Contact1Email" :rules="[{ required: viewModel.IsCompany=='2',message: '联系人邮箱必填', trigger: 'blur'}]" label="联系人邮箱">
                                <el-input v-model="viewModel.Motorcade.Contact1Email"></el-input>
                            </el-form-item>
                            <el-form-item class="form-selected" prop="BankCardID" :rules="[{ required: viewModel.IsCompany=='2',message: '开户银行必填', trigger: 'blur'}]" v-if="isHuoZhu" label="开户银行">
                                <el-select v-model="viewModel.Motorcade.BankCardID" filterable placeholder="开户银行">
                                    <el-option v-for="item in BankCodes" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="BankCardNumber" :rules="[{ required: viewModel.IsCompany=='2',message: '银行账户必填', trigger: 'blur'}]" v-if="isHuoZhu" label="银行账户">
                                <el-input v-model="viewModel.Motorcade.BankCardNumber"></el-input>
                            </el-form-item>
                            <el-form-item prop="KuaiDiAddr" :rules="[{ required: viewModel.IsCompany=='2',message: '快递地址必填', trigger: 'blur'}]" label="快递地址">
                                <el-input v-model="viewModel.Motorcade.KuaiDiAddr"></el-input>
                            </el-form-item>
                            <el-form-item :rules="[{ required: viewModel.IsCompany=='2'}]" label="营业执照">
                                <el-upload :data="{type:'营业执照'}" :on-change="uploadChange" :file-list="YingYeZhiZhaoImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="资质证明">
                                <el-upload :data="{type:'从业资格证'}" :on-change="uploadChange" :file-list="ZiZhiImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item :rules="[{ required: viewModel.IsCompany=='2'}]" v-if="isHuoZhu" label="开户许可证">
                                <el-upload :data="{type:'开户许可证'}" :on-change="uploadChange" :file-list="KaiHuImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item v-if="!isHuoZhu" label="添加车辆">
                                <el-row>
                                    <el-col v-for="item in viewModel.Cars" :key="item.ChePaiHao" :span="8">
                                        <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                            <img :src="item.CheLiangImages[0].url" class="image">
                                            <div style="padding: 4px;">
                                                <span>车牌:{{item.ChePaiHao}}</span>
                                                <div class="bottom clearfix">
                                                    <el-button type="text" @click="removeCar(item)" class="button danger">删除</el-button>
                                                    <el-button type="text" @click="editCar(item)" class="button">编辑</el-button>
                                                </div>
                                            </div>
                                        </el-card>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-card shadow="always">
                                            <div @click="openAddCarDialog" class="add_car">
                                                <i class="el-icon-plus"></i>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                        <!-- <el-form label-width="150px" size="mini">
                            <el-form-item :rules="[{ required: true}]" label="授权书">
                                <a href="javascript:;" @click="downloadItem">授权书模板下载</a>
                                <el-upload :data="{type:'授权书'}" :on-change="uploadChange" :file-list="ShouQuanShuImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-form> -->
                    </p>
                </div>
            </div>
            <div v-if="active==2" class="row">
                <div class="col-md-8 ml-auto mr-auto">
                    <p class="p40" style="padding-top: 40px;">
                        <el-alert center :closable="false" title="提交成功" type="success" description="资料已经提交成功，请等待审核" show-icon></el-alert>
                    </p>
                </div>
            </div>
            <div class="col-md-8 ml-auto mr-auto btns">
                <el-button v-if="active!=2&&active!=0" @click="prev">上一步</el-button>
                <el-button v-if="active!=2" type="primary" :loading="submitLoading" @click="next">下一步</el-button>
            </div>
        </div>
        <el-dialog title="新增/编辑车辆" :visible.sync="dialogVisible" width="650px">
            <car-detail :licenseTypes="licenseTypes" :carStructures="carStructures" :carModels="carModels" @uploadchange="uploadChange" @uploadfile="uploadFile" @uploadremove="uploadRemove" @closedialog="closedialog" @savecar="savecar" :car="currentCar"></car-detail>
        </el-dialog>
        <iframe id="ifile" style="display:none"></iframe>
    </div>
</template>
<script>
    import axios from "axios";
    import util from "../libs/util";
    import api from "../api";
    import carDetail from "../components/carDetail";
    export default {
        components: {
            carDetail
        },
        data() {
            return {
                IDReg: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^((1[1-5])|(2[1-3])|(3[1-7])|(4[1-6])|(5[0-4])|(6[1-5])|71|(8[12])|91)\d{4}((19\d{2}(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(19\d{2}(0[13578]|1[02])31)|(19\d{2}02(0[1-9]|1\d|2[0-8]))|(19([13579][26]|[2468][048]|0[48])0229))((\d{4})|\d{3}[Xx])$)$/,
                isHuoZhu: util.cookies.get("usertype") === "0",
                uploadUrl: process.env.BASE_API+'/Apps/JYJYManage/ClientApi/UploadFile',
                ShenFenZhengImages: [],
                ShenFenZhengImages1: [],
                ShouChiShenFenZhengImages: [],
                JiaShiZhengImages: [],
                YingYeZhiZhaoImages: [],
                ZiZhiImages: [],
                KaiHuImages: [],
                ShouQuanShuImages: [],
                active: 0,
                submitLoading: false,
                dialogVisible: false,
                currentCar: {},
                carModels: [],
                carStructures: [],
                licenseTypes: [],
                BankCodes: [],
                viewModel: {
                    IsCompany: "1",
                    IsDriver: false,
                    IsHaveCar: false,
                    Motorcade: {},
                    Cars: []
                }
            };
        },
        mounted() {
            this.getDictionaries();
        },
        methods: {
            downloadItem() {
                let url = process.env.BASE_API+'/Apps/JYJYManage/Preview/DownloadTemplate?name='
                //个人
                if (this.viewModel.IsCompany == '1') {
                    url += '信息服务授权委托书-个人车主.docx'
                } else {
                    if (this.isHuoZhu) {
                        url += '法人授权委托书-企业货主.docx'
                    } else {
                        url += '信息服务授权委托书-企业车主.docx'
                    }
                }

                document.getElementById("ifile").src = url;
            },
            closedialog() {
                this.dialogVisible = false;
            },
            removeCar(car) {
                var arr = this.viewModel.Cars;
                var index = arr.indexOf(car);
                arr.splice(index, 1);
                this.$set(this.viewModel, "Cars", arr);
            },
            editCar(car) {
                this.currentCar = car;
                this.openAddCarDialog();
            },
            savecar(car) {
                var arr = this.viewModel.Cars;
                var exsit = arr.filter(item => {
                    return item.ChePaiHao == car.ChePaiHao;
                });
                if (exsit.length) {
                    arr.map(item => {
                        if (item.ChePaiHao == car.ChePaiHao) {
                            item = car;
                        }
                    });
                } else {
                    arr.push(car);
                }
                this.dialogVisible = false;
                this.currentCar = {};
                this.$set(this.viewModel, "Cars", arr);
            },
            openAddCarDialog() {
                this.dialogVisible = true;
            },
            uploadFile(f) {
                let param = new FormData();
                param.append("file", f.file);
                param.append("attid", f.file.uid + f.file.size + Math.random());
                param.append("attname", f.file.name);
                param.append("type", f.data.type);
                let config = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: util.cookies.get("access_token")
                    }
                };
                axios
                    .post(f.action, param, config) //上传图片
                    .then(response => {
                        f.onSuccess(response.data);
                    })
                    .catch(err => {
                        f.onError(err);
                    });
            },
            uploadChange(file, fileList) {
                if (file.response) {
                    fileList.forEach(function(item) {
                        if (item.name == file.name) {
                            item.attid = file.response.id;
                            item.type = file.response.type;
                            item.url = process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+file.response.id
                        }
                    });
                    this.updateImgs(file, fileList);
                }
            },
            uploadRemove(file, fileList) {
                let _this = this;
                _this.updateImgs(file, fileList);
            },
            updateImgs(file, fileList) {
                if (file.type == "身份证(正面)") {
                    this.ShenFenZhengImages = fileList;
                }
                if (file.type == "身份证(反面)") {
                    this.ShenFenZhengImages1 = fileList;
                } else if (file.type == "驾驶证") {
                    this.JiaShiZhengImages = fileList;
                } else if (file.type == "手持身份证照片") {
                    this.ShouChiShenFenZhengImages = fileList;
                } else if (file.type == "营业执照") {
                    this.YingYeZhiZhaoImages = fileList;
                } else if (file.type == "从业资格证") {
                    this.ZiZhiImages = fileList;
                } else if (file.type == "行驶证") {
                    this.$set(this.currentCar, "XingShiZhengImages", fileList);
                } else if (file.type == "车辆照片") {
                    this.$set(this.currentCar, "CheLiangImages", fileList);
                } else if (file.type == "授权书") {
                    this.ShouQuanShuImages = fileList;
                } else if (file.type == "开户许可证") {
                    this.KaiHuImages = fileList;
                }
            },
            submit() {
                let _this = this;
                //个人
                if (_this.viewModel.IsCompany == "1") {
                    if (_this.ShenFenZhengImages.length != 1) {
                        _this.$message({
                            message: "身份证正反面照片，各上传一张",
                            type: "error"
                        });
                        return;
                    }
                    if (_this.ShenFenZhengImages1.length != 1) {
                        _this.$message({
                            message: "身份证正反面照片，各上传一张",
                            type: "error"
                        });
                        return;
                    }
                    if (_this.ShouChiShenFenZhengImages.length == 0) {
                        _this.$message({
                            message: "请上传手持身份证照片",
                            type: "error"
                        });
                        return;
                    }
                    // if (_this.viewModel.IsHaveCar && _this.viewModel.Cars.length == 0) {
                    //     _this.$message({
                    //         message: "请添加车辆",
                    //         type: "error"
                    //     });
                    //     return;
                    // }
                    if (_this.viewModel.IsDriver && _this.JiaShiZhengImages.length == 0) {
                        _this.$message({
                            message: "请上传驾驶证照片",
                            type: "error"
                        });
                        return;
                    }
                } else {
                    if (_this.YingYeZhiZhaoImages.length == 0) {
                        _this.$message({
                            message: "请上传营业执照照片",
                            type: "error"
                        });
                        return;
                    }
                    // if (_this.ZiZhiImages.length == 0) {
                    //     _this.$message({
                    //         message: "请上传资质照片",
                    //         type: "error"
                    //     });
                    //     return;
                    // }
                    if (this.isHuoZhu) {
                        if (_this.KaiHuImages.length == 0) {
                            _this.$message({
                                message: "请上传开户许可证照片",
                                type: "error"
                            });
                            return;
                        }
                    } else {
                        // if (_this.viewModel.Cars.length == 0) {
                        //     _this.$message({
                        //         message: "请添加车辆",
                        //         type: "error"
                        //     });
                        //     return;
                        // }
                    }
                }
                // if (_this.ShouQuanShuImages.length == 0) {
                //     _this.$message({
                //         message: "请上传授权书照片",
                //         type: "error"
                //     });
                //     return;
                // }
                _this.viewModel.UserAttachments = [
                    ..._this.ShenFenZhengImages,
                    ..._this.ShenFenZhengImages1,
                    ..._this.ShouQuanShuImages,
                    ..._this.ShouChiShenFenZhengImages,
                    ..._this.JiaShiZhengImages
                ];
                _this.viewModel.MotorcadeAttachments = [
                    ..._this.YingYeZhiZhaoImages,
                    ..._this.ZiZhiImages,
                    ..._this.KaiHuImages,
                    ..._this.ShouQuanShuImages
                ];
                var form = _this.viewModel.IsCompany == "1" ? "form1" : "form2";
                _this.$refs[form].validate(valid => {
                    if (valid) {
                        _this.submitLoading = true;
                        api.saveProfileMore(_this.viewModel).then(res => {
                            _this.submitLoading = false;
                            if (res.data.Succeed) {
                                _this.active = 2;
                                window.scrollTo(0, 0)
                                document.getElementById("profile_more_link").style.display = "none";
                                _this.$message({
                                    message: "资料提交成功",
                                    type: "success"
                                });
                                setTimeout(() => {
                                    _this.$router.push('/profile')
                                }, 2000);
                            } else {
                                _this.$message({
                                    message: "提交失败" + res.data.Message,
                                    type: "error"
                                });
                            }
                        });
                    }
                });
            },
            next() {
                if (this.active == 1) {
                    this.submit();
                }
                if (this.active < 1) {
                    this.active++;
                }
            },
            prev() {
                this.active = 0;
            },
            getDictionaries() {
                let _this = this;
                api
                    .getDictionary({
                        search: {
                            IsEnabled: "",
                            PageNo: 1,
                            PageSize: 1000
                        },
                        tableName: "carModel"
                    })
                    .then(res => {
                        _this.carModels = res.data.Data.Data;
                    });
                api
                    .getDictionary({
                        search: {
                            IsEnabled: "",
                            PageNo: 1,
                            PageSize: 1000
                        },
                        tableName: "carStruct"
                    })
                    .then(res => {
                        _this.carStructures = res.data.Data.Data;
                    });
                api
                    .getDictionary({
                        search: {
                            IsEnabled: "",
                            PageNo: 1,
                            PageSize: 1000
                        },
                        tableName: "LicenseType"
                    })
                    .then(res => {
                        _this.licenseTypes = res.data.Data.Data;
                    });
                //"BankCode"
                api
                    .getDictionary({
                        search: {
                            IsEnabled: "",
                            PageNo: 1,
                            PageSize: 1000
                        },
                        tableName: "BankCode"
                    })
                    .then(res => {
                        _this.BankCodes = res.data.Data.Data;
                    });
            }
        }
    };
</script>
<style scoped>
    div.btns {
        text-align: center;
        padding-bottom: 20px;
    }
    .el-upload--picture-card {
        height: 100px !important;
        width: 100px !important;
        line-height: 100px !important;
    }
    .add_car {
        text-align: center;
        font-size: 50px;
        line-height: 2;
        cursor: pointer;
    }
    .add_car i {
        color: #aaa;
    }
    .JY-RZ p span.el-radio__inner {
        width: 14px !important;
    }
    .JY-RZ p span.el-radio__input,
    .JY-RZ p span.el-radio__label {
        width: auto !important;
    }
    p.fp40 {
        padding-left: 0 !important;
        text-align: center;
    }
    .el-upload-list__item {
        width: 100px !important;
        height: 100px !important;
    }
    .el-upload-list__item-delete {
        width: auto !important;
    }
    .el-card__body img {
        height: 82px;
        width: 100%;
    }
    .button {
        padding: 0;
        float: right;
    }
    .button span {
        width: auto !important;
    }
    .danger {
        color: #f56c6c;
    }
</style>
<style>
    .form-selected input[type=text] {
        width: 268px;
    }
</style>





// WEBPACK FOOTER //
// src/pages/ProfileMore.vue